import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router:Router, private authService: AuthService) { }

  ngOnInit(): void {
    if(this.authService.isUserAdmin()) this.router.navigate(['/admin-dashboard'])
  }

  openQuickSearch(){
    localStorage.setItem('searchType','quick')
    this.router.navigate(['/search'])
  }

  openAdvanceSearch(){
    localStorage.setItem('searchType','advance')
    this.router.navigate(['/search'])
  }

  openSetting(){
    this.router.navigate(['/setting'])
  }

  openSearchHistory(){
    this.router.navigate(['/history'])
  }

}
